// extracted by mini-css-extract-plugin
export default {"container":"CPc6clZBkGBuElP3PuPA"};